import { FormattedMessage } from "react-intl";
import React from "react";
import { gql, useMutation } from "@apollo/client";
import { ConfirmationDialog } from "../../../components/dialogs/confirmation-dialog";
import { GET_COURSE_TEACHINGS } from "../../../apollo-client/queries";

export const EDIT_USER_HOLIDAYS = gql`
  mutation editUserHolidays($onHoliday: HolidayOptions) {
    editUserProfile(onHoliday: $onHoliday) {
      _id
      onHoliday
    }
  }
`;

export const ProfilePageVacationDeactivationDialog = ({
  isDialogOpen,
  toggleDialog,
}) => {
  const [editUserHolidays] = useMutation(EDIT_USER_HOLIDAYS, {
    variables: {
      onHoliday: {
        goOnHoliday: false,
      },
    },
    refetchQueries: [GET_COURSE_TEACHINGS],
    // TODO: refetch teachings query on teachers-page
  });

  const deactivateHoliday = async () => {
    await editUserHolidays();
    toggleDialog();
  };

  return (
    <ConfirmationDialog
      title={<FormattedMessage id="your-tutoring.vacation-deactivate-title" />}
      content={
        <FormattedMessage id="your-tutoring.vacation-deactivate-description" />
      }
      isOpen={isDialogOpen}
      toggle={toggleDialog}
      action={deactivateHoliday}
    />
  );
};
